import React, { useState } from "react";

const PanelAdmin = () => {
  return (
    <div className="d-flex mb-3 h-auto" id="wrapper">
      <h1>داشبورد</h1>
    </div>
  );
};

export default PanelAdmin;
